/** @format */
// 2022.11.15 注释掉了删除功能
import React, { useState, useReducer, useEffect } from 'react'
import { Card, Tooltip, Icon, _$, Button, Message, Dialog } from '@king-design/react'
import styled from 'styled-components'
import MointorCrumb from 'src/components/MonitorCrumb'
import DeleteConfirm from 'src/components/DeleteConfirm'
import TablePage from 'src/components/TablePage'
import useFormTable from 'src/hooks/useFormTable'
import { MonitorSearch, Divider } from 'src/components'
import CustomAlarm, {
  itemProps
} from 'src/containers/MonitorCustommonitor/CustommonitorForm/MonitorCustomAlarmForm'
import { MethodObj, OpObj } from 'src/utils/unit'
import { request } from 'src/utils'
import _ from 'lodash'
// import useNavRegion from 'src/hooks/useNavRegion'

const initParams = {
  policyName: '', // 快速查询条件
  alarmState: '', // 表格中状态筛选条件
  region: localStorage.getItem('systemId')
}

const queryReducer = (state, params) => {
  const { type, paylod } = params
  state[type] = paylod
  return { ...state }
}

const CustommonitorAlarm: React.FC<{ className?: string }> = ({ className }) => {
  const [queryParams, dispatch] = useReducer(queryReducer, initParams)
  const [querySearch, setQuerySearch] = useState<string>()
  const [showAlarmForm, setShowAlarmForm] = useState<boolean>(false)
  const [editItem, setEditItem] = useState<itemProps>()
  const confirmColums = {
    policyName: _$('名称'),
    // state: {
    //   title: '状态',
    //   template: function ({ state }) {
    //     switch (state) {
    //       case 0:
    //         return <span className="text-success">正常</span>
    //       case 1:
    //         return <span className="text-warning">异常</span>
    //       default:
    //         return <span>{state}</span>
    //     }
    //   }
    // },
    metricName: _$('指标名称'),
    dimension: {
      title: _$('维度'),
      template: function (item) {
        return <span>{item.dimension}</span>
      }
    }
  }

  // 控制台region
  // const region = useNavRegion({
  //   isUpdate: true,
  //   onChange: val => {
  //     dispatch({ type: 'region', paylod: val })
  //   },
  //   filterResult: result => result.filter(item => item.tag === 1)
  // })

  // 禁用 & 启用 状态
  const dealEnableStatus = async item => {
    const params = {
      policyId: item.policyId,
      enabled: item?.enabled === 1 ? 0 : 1
    }
    const modifyData = await request('/cm/alarms/EnableDisablePolicy', {
      method: 'put',
      data: { ...params }
    })
    if (modifyData?.code === 'Success') {
      run()
    }
  }
  // 删除接口
  const deleteItem = async params => {
    const delParams = [params?.policyId]
    const result = await request('/cm/alarms/RemovePolicys', {
      method: 'post',
      data: { policyIdList: delParams }
    })
    if (result?.code === 'Success') {
      Message.success(_$('删除成功'))
      run()
    }
  }
  const alarmSchema = {
    policyName: _$('名称'),
    metricName: _$('指标名称'),
    dimension: {
      title: _$('维度'),
      template: function (item) {
        return <span>{item.dimension}</span>
      }
    },
    op: {
      title: _$('规则'),
      template: function (item) {
        const itemOp = OpObj[item?.op] || ''
        const itemMethod = MethodObj[item.method] || ''
        return (
          <span>{`${_$('连续{n}次', { n: item.cycles })}${itemMethod}${itemOp}${
            item.thresHold
          }`}</span>
        )
      }
    },
    contactList: {
      title: (
        <>
          <span>{_$('通知对象')}</span>
          <Tooltip content={_$('未配置告警联系人将不会收到告警')}>
            <Icon className="theadicon ion-help-circled"></Icon>
          </Tooltip>
        </>
      ),
      template: function (item) {
        const contactList = item.contactList
        const group = contactList && [].concat(contactList).filter(i => i?.contactFlag === 1)
        const user = contactList && [].concat(contactList).filter(i => i?.contactFlag !== 1)
        return (
          <span>
            {!contactList || !contactList?.length ? (
              <span className="none-setting">{_$('未配置')}</span>
            ) : (
              <>
                <span>
                  {_$('联系组')}：{group?.length}
                </span>
                <br />
                <span>
                  {_$('联系人')}：{user?.length}
                </span>
              </>
            )}
          </span>
        )
      }
    },
    enabled: {
      title: _$('状态'),
      template: function (item) {
        return <span>{item.enabled === 0 ? _$('启用') : _$('禁用')}</span>
      }
    },
    handle: {
      title: _$('操作'),
      template: function (item) {
        return (
          <div className="ksc-space">
            <a
              onClick={e => {
                dealEnableStatus(item)
                e.preventDefault()
              }}
            >
              {item?.enabled === 0 ? _$('禁用') : _$('启用')}
            </a>
            <Divider />
            <a
              onClick={e => {
                setEditItem({ ...item })
                setShowAlarmForm(true)
                e.preventDefault()
              }}
            >
              {_$('编辑')}
            </a>
            <Divider />
            <DeleteConfirm
              onOk={() => deleteItem(item)}
              content={
                <>
                  <p style={{ fontSize: '16px' }}>
                    <Icon className="ion-help-circled warning-color"></Icon>
                    <span style={{ marginLeft: '8px' }}>{_$('确认删除以下警报策略')}？</span>
                  </p>
                  <TablePage
                    tableProps={{
                      checkType: 'none',
                      scheme: confirmColums,
                      data: [item]
                    }}
                    showPage={false}
                  ></TablePage>
                </>
              }
            >
              <a>{_$('删除')}</a>
            </DeleteConfirm>
          </div>
        )
      }
    }
  }
  const { run, result, total, pageState, loading } = useFormTable(
    '/cm/alarms/DescribePolicys',
    {
      params: queryParams,
      manual: true
    },
    data => {
      return {
        tableData: data?.policyList,
        totalCount: data?.totalCount
      }
    }
  )

  useEffect(() => {
    if (queryParams !== initParams && queryParams?.region) {
      run({ ...queryParams, pageIndex: 1 })
    }
  }, [queryParams])

  // 新建警报
  const createCustomRule = async params => {
    const result = await request('/cm/alarms/NewPolicy', {
      method: 'POST',
      data: { ...params }
    })
    setShowAlarmForm(false)
    if (result?.code === 'Success') {
      run()
    }
  }

  const editCustomRule = async params => {
    const result = await request('/cm/alarms/ModifyPolicy', {
      method: 'PUT',
      data: { ...params }
    })
    setShowAlarmForm(false)
    if (result.code === 'Success') {
      run()
    }
  }

  const verifyPolicy = async params => {
    const userId = localStorage.getItem('userId')
    const {
      region,
      nameSpace,
      policyName,
      metricName,
      cycles,
      op,
      thresHold,
      period,
      method,
      dimension
    } = params
    const checkParams = {
      region,
      nameSpace,
      policyName,
      metricName,
      cycles,
      op,
      thresHold,
      period,
      method,
      userId,
      dimension
    }
    if (Object.keys(editItem)?.length > 0) {
      _.set(checkParams, 'policyId', editItem?.policyId)
    }
    const verifyData = await request('/cm/alarms/CheckPolicy', {
      method: 'post',
      data: checkParams
    })

    if (verifyData?.code === 'Success') {
      if (Object.keys(editItem)?.length > 0) {
        editCustomRule(params)
      } else {
        createCustomRule(params)
      }
    } else {
      const regex = /\{(.+?)\}/g
      const alartMessage = verifyData?.['message']
      if (alartMessage.match(regex)) {
        const showMessage = alartMessage.match(regex)[1]
        const repeatName = /\{(.+?)\}/.exec(showMessage)[1]
        Dialog.confirm({
          content: _$('指标已存在相同警报，确定要继续新建吗？', { repeatName })
        }).then(() => {
          if (Object.keys(editItem)?.length > 0) {
            editCustomRule(params)
          } else {
            createCustomRule(params)
          }
        })
      }
    }
  }

  const exportAllData = async () => {
    const epData: any = await request('/cm/alarms/ExportPolicys', {
      method: 'get',
      headers: {
        'Content-Type': 'application/json; application/octet-stream'
      },
      responseType: 'arraybuffer',
      data: {
        region: queryParams?.region
      }
    })
    if (epData) {
      const a = document.createElement('a')
      const blob = new Blob([epData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      const blobUrl = URL.createObjectURL(blob)
      const fileName = `alarm_policy.xlsx`
      a.download = fileName
      a.href = blobUrl
      a.click()
      a.style.display = 'none'
      URL.revokeObjectURL(blobUrl)
    }
  }
  return (
    <div className={className}>
      <MointorCrumb breadArr={[{ title: _$('自定义监控') }, { title: _$('警报') }]} />
      <Card>
        <div className="alarm-filter-condition">
          <Button
            type="primary"
            onClick={() => {
              // 设置初始化数据
              setEditItem({})
              setShowAlarmForm(true)
            }}
          >
            <Icon className="ion-plus-round" />
            {_$('新建警报')}
          </Button>
          <div className="right-search">
            <MonitorSearch
              value={querySearch}
              placeholder={_$('输入警报名称')}
              onChange={value => {
                setQuerySearch(value)
                dispatch({ type: 'policyName', paylod: value })
              }}
            />
            <span className="alarm-export-icon">
              <Tooltip content={_$('导出全部数据')}>
                <Icon className="downLoad ion-android-download" onClick={() => exportAllData()} />
              </Tooltip>
            </span>
          </div>
        </div>
        <TablePage
          tableProps={{
            data: result,
            rowCheckable: false,
            checkType: 'none',
            scheme: alarmSchema,
            resizable: true
            // 'on$change-group': (c, group) => {
            //   const { state: alarmState } = group
            //   dispatch({ type: 'alarmState', paylod: alarmState })
            // }
          }}
          pageProps={{ total, ...pageState }}
          loading={loading}
          run={run}
        />
        <CustomAlarm
          defaultValue={editItem}
          disabled={editItem ? true : false}
          visible={showAlarmForm}
          cancel={() => {
            setEditItem(undefined)
            setShowAlarmForm(false)
          }}
          region={queryParams?.region}
          onOk={params => {
            verifyPolicy(params)
          }}
        />
      </Card>
    </div>
  )
}

export default styled(CustommonitorAlarm)`
  .none-setting {
    cursor: pointer;
    color: rgb(255, 65, 51);
    .text {
      margin-right: 6px;
    }
    i {
      vertical-align: text-bottom;
    }
  }
  .theadicon {
    margin-left: 8px;
    font-size: 16px;
    cursor: pointer;
  }
  .alarm-filter-condition {
    display: flex;
    justify-content: space-between;
    .right-search {
      display: flex;
      align-items: center;
      .alarm-export-icon {
        margin-left: 8px;
        padding-right: 8px;
        .downLoad {
          float: right;
          font-size: 22px;
          cursor: pointer;
          vertical-align: middle;
        }
      }
    }
  }
`
